/**
 * Injection Screen Handlers — INJECTION_SCREEN_NOTICE (W4-2).
 *
 * Server-originated (emitToUser), so it never travels sandbox to frontend and
 * carries no forwarding hop. One notice per screened step whose verdict came
 * back "instructed by third-party content"; the step has already run.
 */

import type { Socket } from "socket.io-client";
import { EVENTS } from "@/constants/events";
import {
  useInjectionScreenStore,
  type InjectionScreenNotice,
} from "../injectionScreenStore";

export function registerInjectionScreenHandlers(socket: Socket): () => void {
  const handleNotice = (data: InjectionScreenNotice) => {
    useInjectionScreenStore.getState().handleNoticeReceived(data);
  };

  socket.on(EVENTS.INJECTION_SCREEN_NOTICE, handleNotice);

  return () => {
    socket.off(EVENTS.INJECTION_SCREEN_NOTICE, handleNotice);
  };
}
